module.exports = __webpack_public_path__ + "img/balkongelaender.8ac4dc88.jpg";